import React from "react";

// 「＋」で開くアクション行。入力欄の上に1行で並べる。
// 幅は固定せず内容幅を下限にし、SPは余りを等分して伸ばす（タップ面積）、PCは伸ばさず左寄せ。
// 入らない場合は横スクロールではなく折り返す（隠れて気づかれないアクションを作らない）。
function ChatComposerActionRow({ id, actions }) {
  if (!Array.isArray(actions) || actions.length === 0) return null;

  return (
    <div id={id} className="chat-composer__actionRow" role="group" aria-label="送るものを選ぶ">
      {actions.map((action) => (
        <button
          key={action.id}
          type="button"
          className={["chat-composer__actionChip", action.disabled ? "is-disabled" : ""].join(" ")}
          onClick={action.onSelect}
          disabled={action.disabled}
          title={action.fullLabel}
          aria-label={action.fullLabel}
        >
          <i className={action.icon} aria-hidden="true" />
          <span className="chat-composer__actionChipLabel">{action.shortLabel}</span>
        </button>
      ))}
    </div>
  );
}

export default ChatComposerActionRow;
